export default __webpack_public_path__ + "static/media/undraw_empty_street_sfxm.964b779e.svg";